import React, { useState, useEffect, useCallback, useRef } from "react";
import styleStudio from "./styles.module.sass";
import styleFlow from "./stylesFlow.module.sass";
import PlusButton from "./assets/svg/plus_btn.svg";
import { Button, Modal, Toast } from "./helpers/commonUi";
import { Collapse, Tooltip, Icon, Empty } from "antd";
import GridIcon from "./assets/svg/grid.svg";
import ListIcon from "./assets/svg/list.svg";
import ViewIcon from "./assets/svg/view.svg";
import EditIcon from "./assets/svg/editIcon.svg";
import OptionsIcon from "./assets/svg/lefnavOpenlist.svg";
import DeleteIcon from "./assets/svg/delete.svg";
import CaretDownIcon from "./assets/svg/caretDown.svg";
import { getAxiosInstance } from "./helpers/axois";
import "./main.sass";
import CodeEditor2 from "./helpers/CodeEditor2";
import ImportDocument from './ImportDocument'
import { ToastProvider } from './context/ToastContext'
import 'react-data-grid/dist/react-data-grid.css'
import '../src/dataGrid.css'
import DataGrid from 'react-data-grid';
import InfScroll from 'react-infinite-scroll-component';
import { useTheme } from "./context/ThemeContext";

interface IProps {
  collection?: any;
  appId?: string;
  versionId?: string;
  from: string;
  token?: string;
  canEdit?: boolean;
  canDelete?: boolean;
}

let searchCallbackFromEditor: any;
const InfiniteScroll: any = InfScroll;

const Collection = (props: IProps) => {
  const findTheme: any = useTheme()
  const { theme = {} } = findTheme.state
  const style = props.from === "studio" ? styleStudio : styleFlow;
  const [popUpState, setPopUpState] = useState<any>({});
  const [editorValue, setEditorValue] = useState<string>("");
  const [documentViewModalVisible, setDocumentViewModalVisible] = useState<boolean>(false);
  const [documentEditModalVisible, setDocumentEditModalVisible] = useState<boolean>(false);
  const [documentCreateModalVisible, setDocumentCreateModalVisible] = useState<boolean>(false);
  const [documentDeleteModalVisible, setDocumentDeleteModalVisible] = useState<boolean>(false);
  const [documentExportModalVisible, setDocumentExportModalVisible] = useState<boolean>(false);
  const [documentsLoading, setDocumentsLoading] = useState<boolean>(false);
  const [deleteString, setDeleteString] = useState<string>("");
  const [search, setSearch] = useState<string>("");
  const [viewMode, setViewMode] = useState<string>("table");
  const { Panel } = Collapse;
  const collection = props.collection;
  const collectionId = collection && collection.coll_id;
  const appId: any = props.appId;
  const versionId = props.versionId;
  const [documentsList, setDocumentsList] = useState<any[]>([]);
  const [currentDocument, setCurrentDocument] = useState<any>({});
  const [columns, setColumns] = useState<any[]>([]);
  const [headerColumn, setHeaderColumn] = useState<string[]>([]);
  const Http = getAxiosInstance(props.from, props.token);
  let startingData = useRef(0)
  const [hasMoreData, setHasMoreData] = useState(true)
  const [showLabel, setShowLabel] = useState(false)
  let limit = 50;

  const generateDefaults = (entity: any, type: string) => {
    if (type === "object") {
      const newObject: any = {};
      Object.entries(entity.properties).forEach(([key, value]: any[]) => {
        if (value.type === "string") {
          newObject[key] = "";
        } else if (value.type === "number" || value.type === "integer") {
          newObject[key] = 0;
        } else if (value.type === "boolean") {
          newObject[key] = true;
        } else if (value.type === "object") {
          const obj = generateDefaults(value, "object");
          newObject[key] = obj;
        } else if (value.type === "array") {
          const arr = generateDefaults(value, "array");
          newObject[key] = arr;
        } else {
          newObject[key] = "any";
        }
      });
      return newObject;
    } else if (type === "array") {
      const newArray: any = [];
      const type: string = entity.items && entity.items.type;
      if (type === "string") {
        newArray.push("");
      } else if (type === "number" || type === "integer") {
        newArray.push(0);
      } else if (type === "boolean") {
        newArray.push(true);
      } else if (type === "object") {
        const obj = generateDefaults(entity.items, "object");
        newArray.push(obj);
      } else if (type === "array") {
        const arr = generateDefaults(entity.items, "array");
        newArray.push(arr);
      } else {
        newArray.push("any");
      }
      return newArray;
    }
  };

  // Using this effect hook for popup inconsistencies with table view
  useEffect(() => {
    const actionColumn: any = {
      name: "",
      key: "action",
      align: "center",
      width: 20,
      cellClass: "cell1",
      headerCellClass: "header",
      formatter: (record: any) => {
        return (
          <Tooltip
            onVisibleChange={(visible) => {
              setPopUpState({
                [props.from === "studio" ? record.rowIdx : record.row.id]: visible,
              });
            }}
            visible={popUpState[props.from === "studio" ? record.rowIdx : record.row.id]}
            placement="right"
            overlayClassName={"teamPopUp"}
            title={tablePopUpContent(record)}
            trigger="click"
          >
            <OptionsIcon height="24px" width="24px" color={props.from === "studio" ? "#A4B6D6" : theme.secondaryColor} />
          </Tooltip>
        );
      },
    };
    const newColumns = [...columns];
    newColumns[0] = actionColumn;
    setColumns(newColumns);
  }, [popUpState]);

  const generateTableColumns = (data: any) => {
    data.map((record: any) => {
      Object.entries(record.document).map((item: any) => {
        const key: any = item[0];
        if (!headerColumn.includes(key)) {
          setHeaderColumn(h => { h.push(key); return h })
        }
      });
    });
    const defaultColumns: any = {
      name: "",
      key: "action",
      align: "center",
      width: 20,
      cellClass: "cell1",
      headerCellClass: "header",
      formatter: (record: any) => {
        return (
          <Tooltip
            onVisibleChange={(visible) => {
              setPopUpState({
                [props.from === "studio" ? record.doc_id : record.row.id]: visible,
              });
            }}
            visible={popUpState[props.from === "studio" ? record.doc_id : record.row.id]}
            placement="right"
            overlayClassName={"teamPopUp"}
            title={tablePopUpContent(record)}
            trigger="click"
          >
            <OptionsIcon height="24px" width="24px" color={props.from === "studio" ? "#A4B6D6" : theme.secondaryColor} />
          </Tooltip>
        );
      },
    };
    // {
    //   title: "Document ID",
    //   dataIndex: (props.from === 'studio') ? "doc_id" : "id",
    //   key: (props.from === 'studio') ? "doc_id" : "id",
    //   width: 250
    // },
    // {
    //     title: "Created by",
    //     dataIndex: "created_by",
    //     key: "created_by",
    //     width: 250
    // },
    // {
    //     title: "Created at",
    //     dataIndex: "created_at",
    //     key: "created_at",
    //     width: 250,
    //     render: (text:any) => moment(text).format("DD-MM-YYYY"),
    // },
    // {
    //   title: "Data",
    //   dataIndex: "document",
    //   key: "document",
    //   width: 250,
    //   render: (data:any) => `object(Field ${Object.entries(data).length})`,
    // }
    // ]
    const newColumns: any[] = headerColumn.map((key: string) => {
      return {
        name: `${key[0].toUpperCase()}${key.slice(1)}`,
        key: key,
        cellClass: "cell",
        headerCellClass: "header",
        formatter: (record: any) => {
          const value = record.row.document[key];
          if (typeof value === "undefined") {
            return "-";
          }
          if (typeof value !== "object") {
            if (value.length >= 150) {
              return value.substr(0, 150) + " ...";
            } else {
              return `${value}`;
            }
            // return <div></div>;
          }
          if (Array.isArray(value)) {
            return `Array[ ${value.length} ]`;
          }
          const length = Object.entries(value).length;
          return `Object{ ${length} Field${length > 1 ? "s" : ""} }`;
        },
      };
    });
    setColumns([defaultColumns, ...newColumns]);
  };

  function EmptyRowsRenderer() {
    return (
      <Empty style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", flexGrow: 1 }} image={Empty.PRESENTED_IMAGE_SIMPLE} />
    );
  }

  function isAtBottom({ currentTarget }: React.UIEvent<HTMLDivElement>): boolean {
    return currentTarget.scrollTop + 10 >= currentTarget.scrollHeight - currentTarget.clientHeight;
  }

  useEffect(() => {
    if (viewMode == "table") {
      setShowLabel(false)
    }
  }, [viewMode])

  async function handleScroll(event: React.UIEvent<HTMLDivElement>) {
    if (!hasMoreData && isAtBottom(event)) {
      setShowLabel(true)
    } else {
      setShowLabel(false)
    }
    if (documentsLoading || !isAtBottom(event) || !hasMoreData) {
      return
    }
    setDocumentsLoading(true);
    fetchData();
  }

  const setDocuments = (endpoint: string, isFlush: boolean = false) => {
    setDocumentsLoading(true);
    Http.get(endpoint).subscribe(
      (res: any) => {
        generateTableColumns(res);
        if (res.length < limit) {
          setHasMoreData(false);
        } else {
          setHasMoreData(true);
          startingData.current += limit
        };
        if (isFlush) {
          setDocumentsList(res);
        } else {
          setDocumentsList([...documentsList, ...res]);
        };
        setDocumentsLoading(false);
      },
      (_err) => setDocumentsLoading(false)
    );
  };

  const getDocuments = useCallback(() => {
    startingData.current = 0;
    props.from === "studio"
      ? collectionId && setDocuments(`/app/${appId}/coll/${collectionId}/documents?versionId=${versionId}`)
      : collection && collection.collectionName && setDocuments(`a8flow/data/collections/${collection.collectionName}?appId=${collection.appId}&versionCode=${collection.versionCode}&firstResult=${startingData.current}&maxResults=${limit}`)
  }, [collectionId, appId, versionId, collection, props.from]);

  const fetchData = () => {
    collection && setDocuments(`a8flow/data/collections/${collection.collectionName}?appId=${collection.appId}&versionCode=${collection.versionCode}&firstResult=${startingData.current}&maxResults=${limit}`)
  }
  const createDocument = () => {
    const initializedJSON: any =
      props.from === "studio"
        ? collection && collection.coll_schema && generateDefaults(collection.coll_schema, "object")
        : collection && collection.collectionSchema && generateDefaults(collection.collectionSchema, "object");

    setEditorValue(JSON.stringify(initializedJSON, undefined, 4));
    setDocumentCreateModalVisible(true);
  };

  useEffect(() => {
    setDocumentsList(documentList => { documentList.length = 0; return documentList });
    setColumns([]);
    startingData.current = 0;
    setHeaderColumn(header => { header.length = 0; return header });
  }, [collection])

  useEffect(() => {
    getDocuments();
  }, [getDocuments]);

  // const columns: any[] = [
  //     {
  //         title: "",
  //         key: "action",
  //         align: "center",
  //         width: 50,
  //         render: (_text:string, record: any) => {
  //             return (
  //                 <Tooltip
  //                     onVisibleChange={(visible) => setPopUpState({
  //                         [(props.from === 'studio') ? record.doc_id : record.id] : visible
  //                     })}
  //                     visible={popUpState[(props.from === 'studio') ? record.doc_id : record.id]}
  //                     placement='right'
  //                     overlayClassName={'teamPopUp'}
  //                     title={tablePopUpContent(record)}
  //                     trigger='click'
  //                 >
  //                     <OptionsIcon height='24px' width='24px' color='#A4B6D6'/>
  //                 </Tooltip>
  //             )
  //         }
  //     },
  //     {
  //       title: "Document ID",
  //       dataIndex: (props.from === 'studio') ? "doc_id" : "id",
  //       key: (props.from === 'studio') ? "doc_id" : "id",
  //       width: 250
  //     },
  //     {
  //         title: "Created by",
  //         dataIndex: "created_by",
  //         key: "created_by",
  //         width: 250
  //     },
  //     {
  //         title: "Created at",
  //         dataIndex: "created_at",
  //         key: "created_at",
  //         width: 250,
  //         render: (text:any) => moment(text).format("DD-MM-YYYY"),
  //     },
  //     {
  //       title: "Data",
  //       dataIndex: "document",
  //       key: "document",
  //       width: 250,
  //       render: (data:any) => `object(Field ${Object.entries(data).length})`,
  //     }
  // ]

  // const collectionSize: number = Buffer.from(JSON.stringify(documentsList)).length

  // const filterSource = (input : string) => {
  //     if(input){
  //         const filteredSource = source.filter((item:any)=> item.collection_name.toLowerCase().includes(input.toLowerCase()))
  //         setSource(filteredSource)
  //     }else{
  //         setSource(documentsList)
  //     }
  // }

  const tablePopUpContent = (record: any) => {
    return (
      <div className={style.popUpContainer}>
        {
          props.canEdit &&
          <div
            className={style.item}
            onClick={() => {
              setPopUpState({
                [props.from === "studio" ? record.doc_id : record.row.id]: false,
              });
              setCurrentDocument(record);
              setEditorValue(JSON.stringify(record.row.document, undefined, 4));
              setDocumentEditModalVisible(true);
            }}
          >
            <EditIcon height="18px" width="18px" />
            <div className={style.text}>Edit</div>
          </div>
        }
        {
          props.canDelete &&
          <div
            className={style.item}
            onClick={() => {
              setPopUpState({
                [props.from === "studio" ? record.doc_id : record.row.id]: false,
              });
              setCurrentDocument(record);
              setDeleteString(props.from === "studio" ? record.doc_id : record.row.id.toString());
              setDocumentDeleteModalVisible(true);
            }}
          >
            <DeleteIcon height="18px" width="18px" />
            <div className={style.text}>Delete</div>
          </div>
        }
        <div
          className={style.item}
          onClick={() => {
            setPopUpState({
              [props.from === "studio" ? record.doc_id : record.row.id]: false,
            });
            setEditorValue(JSON.stringify(record.row.document, undefined, 4));
            setDocumentViewModalVisible(true);
          }}
        >
          <ViewIcon height="18px" width="18px" />
          <div className={style.text}>View</div>
        </div>
      </div>
    );
  };

  const renderListRow = (keyText?: string, value?: any, index?: number) => {
    if (typeof value !== "object") {
      if (value.length >= 150) {
        value = value.substr(0, 150) + " ...";
      }
    }
    return (
      <div key={index} className={style.listRowContainer}>
        {typeof value !== "object" ? (
          <React.Fragment>
            <span className={style.key}>{keyText}</span>
            <span className={style.value}> : {`${value}`}</span>
          </React.Fragment>
        ) : (
          <Collapse
            className={`override-data-collapse${props.from !== "studio" ? "-flow" : ""} override-data-collapse-inner${props.from !== "studio" ? "-flow" : ""}`}
            expandIcon={({ isActive }) => {
              return (
                <CaretDownIcon
                  height="12px"
                  width="12px"
                  style={{ color: props.from === "studio" ? "#002855" : theme.secondaryColor }}
                  className={isActive ? "override-data-collapse-icon-rotate" : "override-data-collapse-icon-still"}
                />
              );
            }}
          >
            <Panel header={renderListRow(keyText, Array.isArray(value) ? `[ ${value.length} ]` : "{ ... }")} key="1">
              {
                // Rejecting id field since it is included in header
                Object.entries(value).map(([key, value]: any[], index) => {
                  return renderListRow(key, value, index);
                })
              }
            </Panel>
          </Collapse>
        )}
      </div>
    );
  };

  const onCreateDocument = (value: any) => {
    const api =
      props.from === "studio"
        ? Http.post(`/app/${appId}/coll/${collection.coll_name}/documents?versionId=${versionId}`, {
          documents: JSON.parse(value.source),
        })
        : Http.post(`/a8flow/data/collections/${collection.collectionName}`, {
          appId: collection.appId,
          versionCode: collection.versionCode,
          document: JSON.parse(value.source),
        });

    api.subscribe(
      () => {
        // toast({
        //     type: 'success',
        //     message: 'Document created successfully'
        // })
        startingData.current = 0;
        getDocuments();
      },
      (_err: any) => {
        // toast({type: 'error', message: (err && err.message) ? err.message : 'Document creation failed'})
      }
    );
    setDocumentCreateModalVisible(false);
  };

  const onUpdateDocument = (value: any) => {
    const api =
      props.from === "studio"
        ? Http.put(`/app/${appId}/coll/${collection.coll_name}/documents/${currentDocument.row.doc_id}?versionId=${versionId}`, {
          documents: JSON.parse(value.source),
        })
        : Http.put(`a8flow/data/collections/${collection.collectionName}`, {
          appId: collection.appId,
          versionCode: collection.versionCode,
          documentId: currentDocument.row.id,
          document: JSON.parse(value.source),
        });

    api.subscribe(
      () => {
        // toast({
        //     type: 'success',
        //     message: 'Document updated'
        // })
        startingData.current = 0;
        getDocuments();
      },
      (_err: any) => {
        // toast({type: 'error', message: (err && err.message) ? err.message : 'Document updation failed'})
      }
    );
    setDocumentEditModalVisible(false);
  };

  const onDeleteDocument = () => {
    const api =
      props.from === "studio"
        ? Http.delete(`/app/${appId}/coll/${collection.coll_name}/documents/${currentDocument.row.doc_id}?versionId=${versionId}`)
        : Http.delete(
          `/a8flow/data/collections/${collection.collectionName}/delete`,
          {
            data: {
              appId: collection.appId,
              versionCode: collection.versionCode,
              documentId: currentDocument.row.id,
            }
          }
        );

    api.subscribe(
      () => {
        // toast({
        //     type: 'success',
        //     message: 'Document deleted'
        // })
        startingData.current = 0;
        getDocuments();
      },
      (_err: any) => {
        // toast({type: 'error', message: (err && err.message) ? err.message : 'Document deletion failed'})
      }
    );
    setDocumentDeleteModalVisible(false);
  };

  const onFilterDocuments = (value: any, collection: any) => {
    setDocumentsLoading(true);
    // let rawValue = JSON.stringify(value.source);
    // rawValue = rawValue.trim();
    let decodedValue = JSON.parse(value.source);
    const api =
      props.from === "studio"
        ? Http.post(`/a8flow/data/collections/${collection.collectionName}/find`, {
          appId: collection.appId,
          versionCode: collection.versionCode,
          query: decodedValue,
        })
        : Http.post(`/a8flow/data/collections/${collection.collectionName}/find`, {
          appId: collection.appId,
          versionCode: collection.versionCode,
          query: { ...decodedValue },
        });

    api.subscribe(
      (res: any) => {
        // toast({
        //     type: 'success',
        //     message: 'Document deleted'
        // })
        setDocumentsList(res);
        startingData.current = 0
        generateTableColumns(res);
        setDocumentsLoading(false);
      },
      (_err: any) => {
        setDocumentsLoading(false);
        // toast({type: 'error', message: (err && err.message) ? err.message : 'Document deletion failed'})
      }
    );
    setSearch(JSON.stringify(decodedValue));
  };

  const onResetClick = () => {
    getDocuments();
    setSearch("");
  };

  return (Object.keys(collection).length > 0 ?
    <ToastProvider>
      <div className={style.dataDisplayContainer}>
        <div className={style.header}>
          <div className={style.info}>
            <h4>{collection && (props.from === "studio" ? collection.coll_name : collection.collectionName)}</h4>
            <div className={style.data}>
              <h6>Total Documents: {documentsList.length}</h6>
              {/* <h6>Collection Size: {collectionSize} B</h6> */}
            </div>
          </div>
          <div className={style.actionContainer}>
            {
              // Only Allow import and export functionility for flow
              props.from !== "studio" &&
              (
                <React.Fragment>
                  <ImportDocument from={props.from} collection={collection} token={props.token} setDocuments={setDocuments} />
                  <Button disabled={!Object.keys(collection).length} from={props.from} color={theme.secondaryColor} size="extra-small" onClick={() => setDocumentExportModalVisible(true)}>
                    EXPORT
                  </Button>
                </React.Fragment>
              )
            }
            <div title="Grid View">
            <GridIcon
              width="20px"
              height="20px"
              onClick={() => setViewMode("table")}
              style={{
                color: viewMode === "table" ? (props.from === "studio" ? "#0466C8" : theme.secondaryColor) : undefined,
              }}
            />
            </div>
            <div title="List View">
            <ListIcon
              width="20px"
              height="20px"
              onClick={() => setViewMode("list")}
              style={{
                color: viewMode === "list" ? (props.from === "studio" ? "#0466C8" : theme.secondaryColor) : undefined,
              }}
            />
            </div>
            {
              props.canEdit && <PlusButton width="25px" height="25px" style={{ color: props.from === "studio" ? "#0466c8" : theme.secondaryColor }} onClick={() => createDocument()} />
            }
          </div>
        </div>
        {
          // do not show filters and resets on Studio
          props.from !== 'studio' &&
          (
            <div className={style.searchSection}>
              <div className={style.searchCollections} style={{ height: "33px", border: "2px solid #CCD0DD", borderRadius: "6px" }}>
                <CodeEditor2
                  height="27px"
                  value={search}
                  lang={"json"}
                  editRangePhrase={{
                    start: "{",
                    end: "}",
                  }}
                  onSave={(data: any) => {
                    onFilterDocuments(data, collection);
                  }}
                  editorCallback={(callback: any) => {
                    searchCallbackFromEditor = callback;
                  }}
                  hideLang={true}
                />
              </div>
              <Button
                from={props.from}
                color="primary"
                size="extra-small"
                onClick={() => {
                  searchCallbackFromEditor && searchCallbackFromEditor();
                }}
              >
                <Icon type="search" style={{ fontSize: "14px" }} />
                FILTER
              </Button>
              <Button from={props.from} color="secondary" size="extra-small" onClick={() => onResetClick()}>
                RESET
              </Button>
            </div>
          )
        }
        <div className={`${style.listContainer} ${viewMode === "table" ? style.tablePadding : style.listPadding} `} style={{ overflow: "hidden", height: "100%" }} >
          {viewMode === "table" ? (
            <div className="a8DataGrid" style={{ height: "100%" }}>
              <DataGrid
                columns={columns}
                rows={documentsList}
                onScroll={handleScroll}
                emptyRowsRenderer={EmptyRowsRenderer}
              />
              {!hasMoreData && showLabel ? < label className="lable" > Yay! You have seen it all</label > : null}
            </div>
          ) : (
            <div id="listScrollableContainer" className={`${style.listContainer}`} style={{ height: "371px" }}>
              <InfiniteScroll
                hasMore={hasMoreData} next={fetchData} scrollableTarget='listScrollableContainer' dataLength={documentsList.length} endMessage={<p style={{ textAlign: 'center' }}>
                  <b>Yay! You have seen it all</b>
                </p>
                }>
                <Collapse
                  className={`override-data-collapse${props.from !== "studio" ? "-flow" : ""} `}
                  expandIcon={({ isActive }) => {
                    return (
                      <CaretDownIcon
                        height="12px"
                        width="12px"
                        style={{ color: props.from === "studio" ? "#002855" : theme.secondaryColor }}
                        className={isActive ? "override-data-collapse-icon-rotate" : "override-data-collapse-icon-still"}
                      />
                    );
                  }}
                >
                  {documentsList.map((item: any, index: number) => {
                    return (
                      <Panel
                        header={
                          <React.Fragment>
                            {renderListRow("id", props.from === "studio" ? item.doc_id : item.id)}
                            <div className={style.listActionContainer}>
                              {
                                props.canEdit &&
                                (
                                  <>
                                    <div
                                      className={style.iconBox}
                                      onClick={(e) => {
                                        e.stopPropagation();
                                        setEditorValue(JSON.stringify(item.document, undefined, 4));
                                        setCurrentDocument({ row: item });
                                        setDocumentEditModalVisible(true);
                                      }}
                                    >
                                      <EditIcon height="14px" width="14px" style={{ color: props.from === "studio" ? "#0054A8" : "" }} />
                                    </div>
                                  </>
                                )
                              }
                              <div
                                className={style.iconBox}
                                onClick={(e) => {
                                  e.stopPropagation();
                                  setEditorValue(JSON.stringify(item.document, undefined, 4));
                                  setDocumentViewModalVisible(true);
                                }}
                              >
                                <ViewIcon height="14px" width="14px" style={{ color: props.from === "studio" ? "#0054A8" : "" }} />
                              </div>
                              {
                                props.canDelete &&
                                (
                                  <div
                                    id="deleteIconBox"
                                    className={style.iconDeleteBox}
                                    onClick={(e) => {
                                      e.stopPropagation();
                                      setDeleteString(props.from === "studio" ? item.doc_id.toString() : item.id.toString());
                                      setCurrentDocument({ row: item });
                                      setDocumentDeleteModalVisible(true);
                                    }}
                                  >
                                    <DeleteIcon height="14px" width="14px" style={{ color: props.from === "studio" ? "#FD2A0F" : "" }} />
                                  </div>
                                )
                              }
                            </div>
                          </React.Fragment>
                        }
                        key={index}
                      >
                        {
                          // Rejecting id field since it is included in header
                          Object.entries(item.document).map(([key, value]: any[], index) => {
                            return renderListRow(key, value, index);
                          })
                        }
                      </Panel>
                    );
                  })}
                </Collapse>
              </InfiniteScroll></div>
          )}
        </div>
        <Modal
          from={props.from}
          title="VIEW DOCUMENT"
          unmountOnCancel={true}
          footer={{
            enable: false,
            // onOk: () => setDocumentViewModalVisible(false),
            // okText: "SAVE",
            // cancelText: "CANCEL",
          }}
          visible={documentViewModalVisible}
          onCancel={() => setDocumentViewModalVisible(false)}
          width="800px"
          codeEditorProps={{
            height: "450px",
            value: editorValue,
            lang: "json",
            readOnly: true,
          }}
        />
        <Modal
          from={props.from}
          title="DELETE DOCUMENT"
          unmountOnCancel={true}
          footer={{
            enable: true,
            okText: "DELETE",
            cancelText: "CANCEL",
            onOk: onDeleteDocument,
          }}
          deleteOptions={{
            type: "Document",
            validateString: deleteString,
          }}
          visible={documentDeleteModalVisible}
          onCancel={() => setDocumentDeleteModalVisible(false)}
          width="800px"
        />
        <Modal
          from={props.from}
          title="EDIT DOCUMENT"
          unmountOnCancel={true}
          footer={{
            enable: true,
            onOk: () => setDocumentEditModalVisible(false),
            okText: "SAVE",
            cancelText: "CANCEL",
          }}
          visible={documentEditModalVisible}
          onCancel={() => setDocumentEditModalVisible(false)}
          width="800px"
          codeEditorProps={{
            height: "450px",
            value: editorValue,
            lang: "json",
            editRangePhrase: {
              start: "{",
              end: "}",
            },
            onSave: onUpdateDocument,
          }}
        />
        <Modal
          from={props.from}
          title="CREATE DOCUMENT"
          unmountOnCancel={true}
          footer={{
            enable: true,
            onOk: () => setDocumentCreateModalVisible(false),
            okText: "SAVE",
            cancelText: "CANCEL",
          }}
          visible={documentCreateModalVisible}
          onCancel={() => setDocumentCreateModalVisible(false)}
          width="800px"
          codeEditorProps={{
            height: "450px",
            value: editorValue,
            lang: "json",
            editRangePhrase: {
              start: "{",
              end: "}",
            },
            onSave: onCreateDocument,
          }}
        />
        <Modal
          from={props.from}
          title="EXPORT DOCUMENT"
          unmountOnCancel={true}
          footer={{
            enable: false,
          }}
          visible={documentExportModalVisible}
          onCancel={() => setDocumentExportModalVisible(false)}
          width="800px"
          exportDocumentProps={{
            from: props.from,
            collection,
            token: props.token,
            onComplete: () => setDocumentExportModalVisible(false)
          }}
        />
      </div>
      <Toast closeIn={3500} from={props.from} />
    </ToastProvider > : <Empty style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", flexGrow: 1 }} image={Empty.PRESENTED_IMAGE_SIMPLE} />
  );
};

export default Collection;
